import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { useAlerts } from '../../context/AlertContext';
import { useAuth } from '../../context/AuthContext';
import { AlertTriangle } from 'lucide-react';

const LowStockAlertModal = () => {
  const { showAlertModal, currentAlert, acknowledgeAlert, dismissCurrentAlert } = useAlerts();
  const { user } = useAuth();

  if (!currentAlert) return null;

  const handleAcknowledge = () => {
    acknowledgeAlert(currentAlert.id);
  };

  return (
    <Dialog open={showAlertModal} onOpenChange={dismissCurrentAlert}>
      <DialogContent className="sm:max-w-md border-red-600 border-2" data-testid="low-stock-alert-modal">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-red-100 rounded-sm flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-red-600" />
            </div>
            <div>
              <DialogTitle className="text-red-600 font-black text-xl">
                LOW STOCK ALERT
              </DialogTitle>
              <DialogDescription className="text-slate-600">
                Immediate attention required
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-sm p-4">
            <p className="font-mono text-sm text-slate-600 mb-1">Reference</p>
            <p className="font-mono font-bold text-lg text-slate-900">
              {currentAlert.part_reference}
            </p>
          </div>

          <div className="bg-slate-50 rounded-sm p-4">
            <p className="text-sm text-slate-600 mb-1">Description</p>
            <p className="font-medium text-slate-900">{currentAlert.part_description}</p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-red-50 rounded-sm p-4 text-center">
              <p className="text-sm text-slate-600 mb-1">Current Qty</p>
              <p className="text-3xl font-black text-red-600">
                {currentAlert.current_quantity}
              </p>
            </div>
            <div className="bg-slate-50 rounded-sm p-4 text-center">
              <p className="text-sm text-slate-600 mb-1">Minimum Qty</p>
              <p className="text-3xl font-black text-slate-900">
                {currentAlert.minimum_quantity}
              </p>
            </div>
          </div>

          {currentAlert.assigned_user_name && (
            <div className="bg-amber-50 border border-amber-200 rounded-sm p-3">
              <p className="text-sm text-amber-800">
                <span className="font-semibold">Assigned to:</span> {currentAlert.assigned_user_name}
              </p>
            </div>
          )}
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={dismissCurrentAlert}
            className="rounded-sm"
            data-testid="alert-dismiss-btn"
          >
            Remind Later
          </Button>
          <Button
            onClick={handleAcknowledge}
            className="bg-red-600 hover:bg-red-700 text-white rounded-sm"
            data-testid="alert-acknowledge-btn"
          >
            Acknowledge & Handle
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LowStockAlertModal;
